// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"40aa1824","977":"472a69f8"}[chunkId] + ".chunk.js";
};